import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const TrackTraceIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <g clipPath="url(#dhl__illustrations_tracktraceillustration_svg_a)">
      <path
        fill="url(#dhl__illustrations_tracktraceillustration_svg_b)"
        d="m140.56 149.68 26.773-5.333-7.786-3.84-26.854 5.306z"
        opacity={0.6}
      />
      <path
        fill="url(#dhl__illustrations_tracktraceillustration_svg_c)"
        d="m76.693 139.573 26.854-5.306L58 111.627l-26.853 5.306z"
        opacity={0.6}
      />
      <path fill="#FDDE84" d="m103.547 62.347 80-14.347-45.52-22.64L58 39.707z" />
      <path fill="#AA7B33" d="m83.92 52.587 80.027-14.347-7.6-3.76L76.24 48.773z" opacity={0.4} />
      <path fill="#C39000" d="M103.547 62.347v71.92L58 111.627v-71.92z" />
      <path fill="#AA7B33" d="M83.92 52.587V68.16l-7.68-3.947v-15.44z" opacity={0.4} />
      <path fill="#FCCE09" d="M103.547 62.347v71.92l80-14.347V48z" />
      <path fill="#fff" d="M126.987 92.053v27.067l46.72-8.4V83.68z" />
      <path
        fill="#000"
        fillRule="evenodd"
        d="m153.92 109.013 8.187-1.44V91.44l-8.187 1.44zM131.387 112.96l6.933-1.227V95.6l-6.933 1.227zM146 110.4l3.333-.587v-16l-3.413.587zM169.28 90.187l-3.467.613v16.133l3.467-.613zM142.08 111.093l1.387-.24V94.72l-1.387.24z"
        clipRule="evenodd"
      />
      <path
        fill="#3A3A3A"
        d="m163.013 142.427 38.214-6.907a4.403 4.403 0 0 0 3.493-4.16l2.053-73.893c-.986-2.96-4.186-4.667-8.64-3.707L163.467 60a5.14 5.14 0 0 0-4.08 4.88v75.2s0 3.387 2.186 4.267a8 8 0 0 0 3.067.4"
      />
      <path
        fill="#000"
        d="m203.52 137.813-38.187 6.907a2.85 2.85 0 0 1-2.468-.587 2.85 2.85 0 0 1-1.025-2.32v-75.2a4.404 4.404 0 0 1 3.493-4.16l38.214-6.906a2.852 2.852 0 0 1 3.493 2.906v75.2a4.4 4.4 0 0 1-3.52 4.16"
      />
      <path fill="#fff" d="m204.027 128.933-39.28 7.094-.08-64.747 39.28-7.093z" />
      <path fill="#FCCE09" d="m203.947 71.12-39.254 7.067-.026-6.907 39.28-7.093z" />
      <path fill="#E5E5E5" d="m204.027 128.933-39.2 7.094v-6.934l39.2-7.066z" />
      <path fill="#D20612" d="m178.293 74.16-11.866 2.133V72.56l11.84-2.133z" />
      <path fill="#8E8E8E" d="m180.027 119.227-.054-35.04h.4l.054 35.04z" />
      <path
        fill="#8E8E8E"
        d="M181.52 83.947a1.68 1.68 0 0 1-1.333 1.6 1.094 1.094 0 0 1-1.334-1.12 1.68 1.68 0 0 1 1.334-1.6 1.094 1.094 0 0 1 1.333 1.12M180.187 97.227a1.092 1.092 0 0 1-1.334-1.12 1.68 1.68 0 0 1 1.334-1.6 1.092 1.092 0 0 1 1.333 1.12 1.68 1.68 0 0 1-1.333 1.6M175.813 84.56l-3.333.613v1.04l3.333-.613zM175.813 96.293l-3.333.587v1.04l3.333-.613zM198.08 80.56l-13.627 2.453v1.04L198.08 81.6zM196.213 92.613l-11.76 2.134v1.04l11.76-2.134zM184.453 85.947v1.04l7.814-1.387v-1.04zM181.52 107.36a1.68 1.68 0 0 1-1.333 1.6 1.092 1.092 0 0 1-1.334-1.12 1.68 1.68 0 0 1 1.334-1.6 1.092 1.092 0 0 1 1.333 1.12M175.813 107.973l-3.333.587v1.04l3.333-.587zM198.08 103.973l-13.627 2.454v1.04l13.627-2.454zM184.453 109.36v1.04l7.814-1.413v-1.04zM180.187 120.667a1.092 1.092 0 0 1-1.334-1.12 1.68 1.68 0 0 1 1.334-1.6c.164-.038.335-.036.499.004s.316.116.445.225a1.08 1.08 0 0 1 .389.891 1.68 1.68 0 0 1-1.333 1.6M175.813 119.733l-3.333.587v1.04l3.333-.613zM196.213 116.053l-11.76 2.107v1.04l11.76-2.107z"
      />
    </g>
    <defs>
      <linearGradient
        id="dhl__illustrations_tracktraceillustration_svg_b"
        x1={146.466}
        x2={148.268}
        y1={146.537}
        y2={140.929}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_tracktraceillustration_svg_c"
        x1={59.933}
        x2={67.173}
        y1={129.998}
        y2={114.541}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
      <clipPath id="dhl__illustrations_tracktraceillustration_svg_a">
        <path fill="#fff" d="M0 0h240v160H0z" />
      </clipPath>
    </defs>
  </BaseIllustration>
)
